@if (consent.showBanner()) {
  <div
    class="cookie-consent"
    role="region"
    aria-label="Cookie consent"
    aria-live="polite">
    <div class="cookie-consent-inner">
      <p class="cookie-consent-text">
        We use cookies to improve your experience, remember preferences, and understand how our site is used.
        By clicking &ldquo;Accept all&rdquo;, you agree to optional cookies as described in our
        <a routerLink="/privacy" class="cookie-consent-link">Privacy Policy</a>.
        &ldquo;Reject all&rdquo; keeps only cookies required for the site to work.
      </p>
      <div class="cookie-consent-actions">
        <button
          type="button"
          class="cookie-btn cookie-btn-secondary"
          (click)="acceptNecessaryOnly()"
          aria-label="Reject non-essential cookies">
          Reject all
        </button>
        <button
          type="button"
          class="cookie-btn cookie-btn-primary"
          (click)="acceptAll()">
          Accept all
        </button>
      </div>
    </div>
  </div>
}
